import React, {FC, useEffect, useState} from 'react';
import { useStoreon } from 'storeon/react';
import {
  GxButton,
  GxCheckbox,
  GxIcon,
} from '@garpix/garpix-web-components-react';
import { FormikProps } from 'formik';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss';
import Switcher from '../../../../components/Switcher';
import { TYPES_STATUS } from '../../consts';
import ManualStock from '../../../../components/ManualStock';
import Input from '../../../../components/Input';
import { IndicatorIcon } from '../../../../assets';
import {
  checkAutomaticStockMulti,
  checkAutomaticStockOrder,
  checkManualStockMulti,
  checkManualStockOrder,
  checkPromoCode,
  checkPromoCodeMylti,
} from './helpers';
import { TYPE_USER } from '../../../../const';

interface IOrderStock {
  data?: Record<string, any> | null;
  date?: string | null;
  formik: FormikProps<any>;
  statusLoad: boolean;
}

const ModalOrderStock: FC<IOrderStock> = ({
  formik,
  data,
  date,
}) => {
  const {
    arrayDateTimeOrders,
    statusCreateMultiOrders,
    currentUser,
    typeOrder,
  } = useStoreon<State, Events>(
    'typeOrder',
    'arrayDateTimeOrders',
    'currentUser',
    'statusCreateMultiOrders',
    'ordersInfo'
  );
  const [automaticFlag, setAutomaticFlag] = useState<boolean>(true);
  const orderStatus = data?.status;
  const isDisabledField = orderStatus === TYPES_STATUS.PAY_LOCAL ? false : Boolean(data);

  // Проверка автоматической акции
  useEffect(() => {
    if (
      formik.values.customer &&
      !data &&
      statusCreateMultiOrders &&
      arrayDateTimeOrders.length > 0
    ) {
      checkAutomaticStockMulti(
          arrayDateTimeOrders,
          formik,
          typeOrder,
          currentUser,
          setAutomaticFlag
      );
    }
  }, [
    formik.values.customer,
    formik.values.tariff_rate,
    formik.values.tariff_rate_multi,
  ]);

  useEffect(() => {
    if (
        formik.values.customer &&
        formik.values.tariff_rate.id &&
        !statusCreateMultiOrders && formik.values.is_automatic_stock
    ) {
      checkAutomaticStockOrder(formik, date, currentUser, setAutomaticFlag);
    }
  }, [formik.values.tariff_rate.id])

  const changeSwitcher = (e: any) => {
    formik.setFieldValue('discount', e.target.checked)
  }

  return (
      <div className={styles['discount']}>
        <div className={styles['discount--item']}>
          <div className={styles['discount-status']}>
            <Switcher
                label='Блок скидок:'
                checked={formik.values.discount}
                disabled={
                  orderStatus === TYPES_STATUS.PAY_LOCAL ? false : (
                      statusCreateMultiOrders
                          ? arrayDateTimeOrders.length === 0
                          : !formik.values.tariff_rate.id ||
                          currentUser.user_status === TYPE_USER.VIEWER
                  )}
                onGx-change={changeSwitcher}
            />
          </div>
      </div>
      <>
        {formik.values.discount &&
          formik.values.customer &&
          (formik.values.tariff_rate.id || formik.values.tariff_rate_multi) && (
            <>
              <div className={styles['discount--item']}>
                <GxCheckbox
                  name='is_automatic_stock'
                  className={styles['item-children']}
                  onGx-change={(e: Record<string, any>) => {
                    formik.setFieldValue(
                      'is_automatic_stock',
                      e.target.checked
                    );
                    if (!e.target.checked) {
                      formik.setFieldValue('price_stock', 0);
                      formik.setFieldValue('stock', null);
                      formik.setFieldValue('stock_name', null);
                    } else if (
                      statusCreateMultiOrders &&
                      arrayDateTimeOrders.length > 0
                    ) {
                      checkAutomaticStockMulti(
                        arrayDateTimeOrders,
                        formik,
                        typeOrder,
                        currentUser,
                        setAutomaticFlag
                      );
                    } else {
                      checkAutomaticStockOrder(
                        formik,
                        date,
                        currentUser,
                        setAutomaticFlag
                      );
                    }
                  }}
                  checked={formik.values.is_automatic_stock}
                  disabled={orderStatus === TYPES_STATUS.PAY_LOCAL && automaticFlag ? false : !!data }
                >
                  Автоматическая скидка
                </GxCheckbox>
              </div>
              <div className={styles['discount--item']}>
                <>
                  <ManualStock
                    classNameBlock={styles['discount--select']}
                    user_id={formik.values.customer.value}
                    tariff_rate={formik.values.tariff_rate.id}
                    value={formik.values.manual_stock}
                    side={typeOrder}
                    type='order'
                    onChangeSelect={(e) => {
                      formik.setFieldValue('manual_stock', e);
                      if (
                        statusCreateMultiOrders &&
                        arrayDateTimeOrders.length > 0 &&
                        e
                      ) {
                        checkManualStockMulti(
                          arrayDateTimeOrders,
                          e,
                          formik,
                          currentUser,
                        );
                      } else if (e) {
                        checkManualStockOrder(
                          formik,
                          e,
                          currentUser,
                          typeOrder
                        );
                      } else {
                        formik.setFieldValue('stock_name', null);
                        formik.setFieldValue('price_stock', 0);
                      }
                    }}
                    isDisabled={isDisabledField}
                  />
                  <div className={styles['promocode']}>
                    <span className={styles['discount-status--label']}>
                      Промокод:
                    </span>
                    <label
                      htmlFor='promo_code'
                      className={styles['promocode--group']}
                    >
                      <Input
                        clearable={formik.values.promo_code}
                        name='promo_code'
                        placeholder='XXXX-XXXX-XXXX'
                        className={styles['promocode--input']}
                        value={formik.values.promo_code}
                        onGx-input={(e: Record<string, any>) => {
                          formik.setFieldValue('promo_code', e.target.value);
                        }}
                        onGx-clear={() => {
                          formik.setFieldValue('promo_code', null);
                          formik.setFieldValue('stock', null);
                          formik.setFieldValue('price_stock', 0);
                          formik.setFieldValue('stock_name', null);
                        }}
                        disabled={isDisabledField}
                      />
                      <GxButton
                        className={styles['promocode--btn']}
                        disabled={isDisabledField}
                        onClick={() => {
                          if (
                            statusCreateMultiOrders &&
                            arrayDateTimeOrders.length > 0
                          ) {
                            checkPromoCodeMylti(
                              arrayDateTimeOrders,
                              formik,
                              currentUser
                            );
                          } else {
                            checkPromoCode(
                              formik,
                              date,
                              formik.values.promo_code,
                              currentUser
                            );
                          }
                        }}
                      >
                        <GxIcon
                          className={styles['promocode--btn-icon']}
                          src={IndicatorIcon}
                        />
                      </GxButton>
                    </label>
                  </div>
                </>
              </div>
            </>
          )}
      </>
    </div>
  );
};

export default ModalOrderStock;
